import React, { useCallback } from 'react';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import { FilterBodyProps } from '@/components/FilterNew/components/Body/types';
import { InlineTagDatePicker } from '@/modules/corporate/modules/tags/components/TagDatePicker';
import { TagValues } from '@/modules/corporate/modules/tags/types';
import { FilterOperatorEnum } from '@/types/schema';

import FilterHeader from '../../FilterNew/components/Header';

function DateTagFilter({
  uiConfig,
  onChange,
  headerProps,
  initialSelectedOptions,
  initialSelectedOperator,
}: FilterBodyProps) {
  const { showActionButtons = true, datePicker } = uiConfig ?? {};
  const { t } = useTranslation();

  const onChangeValue = useCallback(
    (initialValue: TagValues) => {
      if (!initialValue || typeof initialValue !== 'object' || Array.isArray(initialValue)) {
        return;
      }

      const { startTime, endTime = startTime } = initialValue;

      onChange(
        [
          {
            label: '',
            value: JSON.stringify({
              startTime: startTime ? startOfDay(new Date(startTime)).toISOString() : undefined,
              endTime: endTime ? endOfDay(new Date(endTime)).toISOString() : undefined,
            }),
          },
        ],
        {
          id: FilterOperatorEnum.Equal,
          label: t('Common:On'),
          value: FilterOperatorEnum.Equal,
        },
      );
    },
    [onChange, t],
  );

  return (
    <Box>
      <FilterHeader {...headerProps} />
      <InlineTagDatePicker
        includeEndDate={!!datePicker?.includeEndDate}
        includeTime={!!datePicker?.includeTime}
        selectedTagValue={initialSelectedOptions}
        showActionButtons={showActionButtons}
        onChange={onChangeValue}
      />
    </Box>
  );
}

export default DateTagFilter;
